export const ROLE_FRIENDLY_MAP = {
  '1': 'Authorized Organization Representative',
  '2': 'Organization Member',
  '3': 'Program Administrator',
  '4': 'Grants Management Specialist',
  '5': 'Assistance Officer',
  '6': ' Program Specialist',
  '7': 'System Administrator',
  '8': 'Authorized Signature Authority',
  '9': 'Office of Chief Counsel (Grant)',
  '10': 'Panel Reviewer',
  '11': 'Panel Chair',
  '12': 'Panel Review Coordinator',
  '13': 'EHP Administrator',
  '14': 'EHP Reviewer',
  '15': 'Grants Counsel Staff',
  '16': 'Grants Counsel Administrator',
  '17': 'Programmatic Member',
  '18': 'Financial Member',
  '19': 'Grant Writer',
  '20': 'Subrecipient Member',
  '21': 'Subrecipient Authorized Representative',
  '22': 'EHP Service User',
  '23': 'Panel Review Administrator',
  '24': 'NTR Reviewer',
  '25': 'Analytics User',
  '26': 'Analytics Administrator',
  '27': 'Release Manager',
  '28': 'Senior Program Administrator',
  '31': 'Authorized Signature Authority, Region 1',
  '32': 'Authorized Signature Authority, Region 2',
  '33': 'Authorized Signature Authority, Region 3',
  '34': 'Authorized Signature Authority, Region 4',
  '35': 'Authorized Signature Authority, Region 5',
  '36': 'Authorized Signature Authority, Region 6',
  '37': 'Authorized Signature Authority, Region 7',
  '38': 'Authorized Signature Authority, Region 8',
  '39': 'Authorized Signature Authority, Region 9',
  '40': 'Authorized Signature Authority, Region 10',
  '41': 'System Owner',
  '42': 'Service Management Administrator',
  '43': 'Human Resources Liaison',
  '44': 'Service Management User',
  '45': 'Obligating Authority POC',
  '46': 'Senior Assistance Officer',
  '47': 'Senior EHP Administrator',
  '48': 'Senior Grants Counsel Administrator',
  '49': 'Senior Analytics Administrator',
  '50': 'Designated De-obligating Authority',
  '51': 'Designated De-obligating Authority, Region 1',
  '52': 'Designated De-obligating Authority, Region 2',
  '53': 'Designated De-obligating Authority, Region 3',
  '54': 'Designated De-obligating Authority, Region 4',
  '55': 'Designated De-obligating Authority, Region 5',
  '56': 'Designated De-obligating Authority, Region 6',
  '57': 'Designated De-obligating Authority, Region 7',
  '58': 'Designated De-obligating Authority, Region 8',
  '59': 'Designated De-obligating Authority, Region 9',
  '60': 'Designated De-obligating Authority, Region 10',
  '61': 'Read Only',
  '62': 'Program Delivery Manager',
  '63': 'Program Delivery Manager Supervisor',
};

export const getRolesFromPermissions = (permissions) => {
  const roleSet = new Set();

  for (const perm of permissions) {
    const friendlyRoleName = getRoleFromPermission(perm);

    if (friendlyRoleName) {
      roleSet.add(friendlyRoleName);
    }
  }

  return Array.from(roleSet);
};

const getRoleFromPermission = (permission) => {
  const permissionSplit = permission.split(':');
  if (permissionSplit.length > 1) {
    const roleToFind = permissionSplit[permissionSplit.length - 1];
    if (roleToFind in ROLE_FRIENDLY_MAP) {
      return ROLE_FRIENDLY_MAP[roleToFind];
    }
  }

  return '';
};
